import { cn } from "@/lib/utils";

interface StreamingQuipRowProps {
  message: string | null;
  className?: string;
}

/** Rotating streaming status copy (no avatar column). */
const StreamingQuipRow = ({ message, className }: StreamingQuipRowProps) => {
  if (message == null) return null;

  return (
    <div className={cn("w-full min-w-0", className)} aria-hidden>
      <div className="text-sm leading-relaxed animate-streaming-quip-gradient">
        {message}
      </div>
    </div>
  );
};

export default StreamingQuipRow;
